export enum AppRoutes {
  portfolio = 'portfolio',
  pricelist = 'pricelist',
  offers = 'offers',
  catalogue = 'catalogue',
  imports = 'imports',
  plcards = 'plcards',
  changelog = 'changelog'
}
